import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import Usuarios from './Usuarios';
import DeleteIcon from '@material-ui/icons/Delete';
import { keys } from '@material-ui/core/styles/createBreakpoints';
import Unidadetransporte from '../componentes/unidadetransporte1';
import Tooltip from '@material-ui/core/Tooltip';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
 
  
  avatar: {
    backgroundColor: red[500],
  },
}));


     
    
  
  
export default function RecipeReviewCard(props) {
  
  const [statecampi,setstatecampi]=React.useState("Campus Santa Maria");
  const [unidadetransporte,setaunidadetransporte]=React.useState("");
  
  React.useEffect(() => { // esse é responsável em pegar as alterações
    props.trans(unidadetransporte)
   },[unidadetransporte]);

  const classes = useStyles();
  
  
  return (
    <div>
              <FormControl  fullWidth variant="outlined"  className={classes.root}>
            <InputLabel required htmlFor="departamentochefe">Campus</InputLabel>
              <Select
                
                labelId="selectcampichefe"
                id="selectcampichefe"
                value={statecampi}
                onChange={e=>setstatecampi(e.target.value)}
                label="selectcampichefe"
        
              >
                <MenuItem key = {1} value={"Campus Santa Maria"}>Campus Santa Maria</MenuItem>
                <MenuItem key = {2} value={"Campus Cachoeira do Sul"}>Campus Cachoeira do Sul</MenuItem>
                <MenuItem key = {3} value={"Campus Frederico Westphalen"}>Campus Frederico Westphalen</MenuItem>
                <MenuItem key = {4} value={"Campus Palmeira das Missões"}>Campus Palmeira das Missões</MenuItem>
              </Select>
          
         
        
          </FormControl>
          <br></br>
          
          <div id="undmotora" className={classes.root} >
        <Unidadetransporte requer={true} 
        campi={statecampi} setaunidadetransporte={setaunidadetransporte} />
                
              <br>{console.log("br")}</br>
          
          </div>
          
                    

            </div>
  );
}